import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { lessonApi, ILessonSessionResults } from 'common/modules/ReactShared';

const initialSessionResults: ILessonSessionResults = {
  tasks: [],
  taskItemsPublishedCount: 0,
  taskItemsCorrectlyAnsweredCount: 0
};

const fetchLessonSessionResults = createAsyncThunk<ILessonSessionResults, number>(
  'lessonSession/fetchResults_request',
  async (sessionId) => {
    const resp = await lessonApi.fetchLessonSessionResults(sessionId);
    return resp;
  }
);

const resultsSlice = createSlice({
  name: 'sessionResults',
  initialState: initialSessionResults as ILessonSessionResults,
  reducers: {
    clear: () => initialSessionResults
  },
  extraReducers: (builder) => {
    builder.addCase(fetchLessonSessionResults.fulfilled, (_, action) => {
      return action.payload;
    });

    builder.addCase(fetchLessonSessionResults.rejected, () => {
      return initialSessionResults;
    });
  }
});

const { reducer, actions } = resultsSlice;

export const resultsActions = { ...actions, fetchLessonSessionResults };

export default reducer;
